/**
 * 导航菜单配置
 * 定义侧边栏菜单结构
 */

import { ROUTES } from './routes'

export interface NavItem {
  label: string
  path?: string
  icon: string
  children?: NavItem[]
  roles?: ('student' | 'teacher')[]
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: '首页',
    path: ROUTES.HOME,
    icon: 'Home',
  },
  {
    label: '考试练习',
    icon: 'FileText',
    children: [
      { label: '试卷列表', path: ROUTES.EXAM, icon: 'List' },
      { label: '答题历史', path: ROUTES.EXAM_HISTORY, icon: 'History' },
    ],
  },
  {
    label: '错题本',
    path: ROUTES.MISTAKES,
    icon: 'BookOpen',
  },
  {
    label: 'AI学习中心',
    icon: 'BrainCircuit',
    children: [
      { label: '自助备考', path: ROUTES.EXAM_PREP, icon: 'Target' },
      { label: '诊断', path: ROUTES.AI_TEAM_DIAGNOSIS, icon: 'Stethoscope' },
      { label: '课程', path: ROUTES.AI_TEAM_COURSES, icon: 'GraduationCap' },
      { label: '每日任务', path: ROUTES.AI_TEAM_TASKS, icon: 'CheckSquare' },
    ],
  },
  {
    label: '教师工作区',
    icon: 'Presentation',
    roles: ['teacher'],
    children: [
      { label: '课件管理', path: ROUTES.TEACHER, icon: 'FileText' },
    ],
  },
  {
    label: '工具',
    icon: 'Wrench',
    children: [
      { label: 'AI辅导', path: ROUTES.TUTOR, icon: 'MessageSquare' },
      { label: '题目讲解', path: ROUTES.QUESTION_PLAYER, icon: 'Presentation' },
      { label: '几何大师', path: ROUTES.GEOMASTER, icon: 'Shapes' },
      { label: '小华老师', path: ROUTES.XIAOHUA, icon: 'Paintbrush' },
      { label: '知识点', path: ROUTES.KNOWLEDGE_POINTS, icon: 'Network' },
    ],
  },
]
